import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, GangAddEdit } from './Pages';

export const GangRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing} />
        <Route exact path = {`${match.path}/addEdit`} component={GangAddEdit} />
    </Fragment>
)